import(/* webpackMode: "eager" */ "/vercel/path0/app/thank-you/page.jsx");
